import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { EmailDesignSchema } from "../../email-design/types/email-design-type";
import { CeAlign } from "../../generic/components/form-fields/ce-align";
import { CeColourField } from "../../generic/components/form-fields/ce-colour-field";
import { CeTextInput } from "../../generic/components/form-fields/ce-text-field";
import { FormStack } from "../../generic/components/form-fields/form-stack";

export const HeaderTextSettingsEditor: FC = () => {
  const { t } = useTranslation();

  return (
    <FormStack>
      <CeAlign<EmailDesignSchema> analyticsCategory="email_design" name="header.text.align" />
      <CeTextInput<EmailDesignSchema>
        analyticsCategory="email_design"
        name="header.text.value"
        label={t("Header Text")}
      />
      <CeColourField<EmailDesignSchema>
        analyticsCategory="email_design"
        name="header.text.color"
        label={t("Header Text Color")}
      />
    </FormStack>
  );
};
